// React & Vendor Libs
const { useMemo, useState } = wp.element;
import useSWR from 'swr';

import { useNekoTasks } from 'neko-ui';

// NekoUI
import { NekoButton, NekoTypo, NekoProgress, NekoModal, NekoPage,
	NekoBlock, NekoHeader, NekoContainer, NekoSettings, NekoInput, NekoWrapper, NekoColumn } from 'neko-ui';

// Copytrack
import { apiUrl, jsonFetcher } from '../helpers';
import { useEffect } from 'react';


const Dashboard = () => {

  const { data: allPending, error: pendingError } = useSWR(`${apiUrl}/pending`, jsonFetcher);
  const { data: account, mutate: mutateAccount } = useSWR(`${apiUrl}/account/`, jsonFetcher);
  const mediaIds = useMemo(() => { return allPending ? allPending.data : null; }, [ allPending ]);

  // Hooks
  const [ status, setStatus ] = useState('Idle.');
  const [ busy, setBusy ] = useState(false);
  const [ finalMessage, setFinalMessage ] = useState(false);
  const nekoTasks = useNekoTasks();

  const isInit = account !== undefined;
  const key = isInit ? account.data.key : '';
  const token = isInit ? account.data.token : '';
  const isReady = key && token;
  
  const startProcess = () => {
    let tasks = mediaIds.map(mediaId => async (signal) => {
      setStatus(`Uploading Media #${mediaId}...`);
      const res = await fetch(`${apiUrl}/upload/${mediaId}`, { signal, method: 'POST' });
      return await res.json();
      //return { success: true };
    });
    nekoTasks.start(tasks);
  };

  useEffect(() => {
    if (!nekoTasks.busy) {
      setStatus(`Idle.`);
    }
  }, [nekoTasks.busy]);

  useEffect(() => {
    if (nekoTasks.success) {
      let errorCount = nekoTasks.getErrorCount();
      if (errorCount > 0) {
        setFinalMessage(`Thanks for using Image Copytrack! The process has finished, but ${errorCount} error(s) occurred. They have been logged in the console.`);
      }
      else {
        setFinalMessage('Thanks for using Image Copytrack! It\'s all done, for now :)');
      }
    }
  }, [nekoTasks, nekoTasks.success]);

  const onSetOption = async (name, value) => {
    setBusy(true);
    const data = { name: `${name}`, value };
    const res = await fetch(`${apiUrl}/update_option/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    const result = await res.json();
    const newData = { ...account.data, [name]: result.data };
    mutateAccount({ data: newData }, false);
    setBusy(false);
  };

  const onAlwaysSkip = async () => {
    nekoTasks.setAlwaysSkip(true);
    nekoTasks.resume();
  };
  
	return (
		<NekoPage>
      <NekoHeader title='Image Copytrack' />
      <NekoWrapper>
        <NekoColumn>
          <NekoBlock title="Copytrack Account" className="primary">
            <NekoSettings title="Key">
              <NekoInput value={key} placeholder="Enter your key" readOnly={busy} onBlur={value => onSetOption('key', value)} />
            </NekoSettings>
            <NekoSettings title="Token">
              <NekoInput value={token} placeholder="Enter your token" readOnly={busy} onBlur={value => onSetOption('token', value)} />
            </NekoSettings>
          </NekoBlock>
          <NekoContainer
            style={{ marginTop: '30px', marginBottom: '0' }}
            header={
              <React.Fragment>
                <NekoButton disabled={!mediaIds} onClick={startProcess} disabled={!isReady || nekoTasks.busy} style={{ marginRight: 10 }}>
									Upload {mediaIds ? mediaIds.length : 0} Photos
								</NekoButton>
                <NekoTypo span>{status}</NekoTypo>
              </React.Fragment>
          }>
            <NekoProgress busy={nekoTasks.busy} value={nekoTasks.value} max={nekoTasks.max} onStopClick={nekoTasks.stop} />
          </NekoContainer>
        </NekoColumn>
        <NekoColumn>
          <NekoContainer style={{ height: '100%' }}>
            <NekoTypo h2>How does it work</NekoTypo>
            <NekoTypo p>
              To use this plugin, you will need a key and a token from Copytrack. For that, simply click on this link: <a target="_blank" href='https://app.copytrack.com/application/authorize?name=WP%20CopyTrack'>CopyTrack</a>. You can submit your images from the Media Library or here, in bulk.
            </NekoTypo>
            <NekoTypo h2>Media Library</NekoTypo>
						<NekoTypo p>In the Media Library, you can check the status of each entry.</NekoTypo>
            <NekoTypo h2>Bulk Upload</NekoTypo>
						<NekoTypo p>In this dashboard, you can click on <b>Upload Photos</b> and all the Media entries which haven't been uploaded yet to Copytrack will be.</NekoTypo>
          </NekoContainer>
        </NekoColumn>
      </NekoWrapper>

      <NekoModal isOpen={nekoTasks.error} 
        title="Error"
        content={nekoTasks.error}
        ok='Skip' onOkClick={nekoTasks.resume} 
        cancel='Stop' onCancelClick={nekoTasks.stop}
        customButtons={<NekoButton onClick={onAlwaysSkip}>Always Skip</NekoButton>}
      />

      <NekoModal isOpen={nekoTasks.success} 
        title="Success" 
        content={finalMessage}
        ok='Close' onOkClick={nekoTasks.reset}
      />
      
    </NekoPage>
	);
};

export default Dashboard;